export const routerSelector = state => state.router;

export const locationSelector = state => routerSelector(state)?.location;

export const searchSelector = state => locationSelector(state)?.search;

export const routeSelector = state => locationSelector(state)?.pathname;
